import React from 'react';
import { Row, Column } from '../Common/Grid';
import OrderSummary from './OrderSummary';
import OrderTotalSummary from './OrderTotalSummary';
import OrderDetailsCTAGroup from './OrderDetailsCTAGroup';
import OrderItemsContainer from './OrderItemsContainer';
import WssPaymentAuthorizationSection from './WssPaymentAuthorizationSection';
import { orderDetailsDataProps, orderDetailsDataDefaultProps } from './props';

export default function OrderDetailsContent({ queryData }) {
  const orderDetailItems = queryData?.orderDetails?.orderDetailItems || {};

  const {
    billingInfo,
    shippingDetails,
    vatDutyDetails,
    summary,
    ctaGroup,
    products,
    packages,
    wssPaymentDetails,
    orderNumber,
  } = orderDetailItems;

  const {
    pleaseTryAgain,
    processingText,
    successText,
  } = queryData?.textFor || {};

  return (
    <div className="order-details-content" data-testid="order-details-content">
      {wssPaymentDetails && wssPaymentDetails.paymentUpdateNeeded && (
        <WssPaymentAuthorizationSection orderNumber={orderNumber} />
      )}
      <Row>
        { summary
        && (
        <Column md="4">
          <div className="order-total-summary" data-testid="order-total-summary">
            <OrderTotalSummary summary={summary} />
          </div>
        </Column>
        )}
        { ctaGroup && (
        <Column md="4">
          <div className="order-details-cta-group" data-testid="order-details-cta-group">
            <OrderDetailsCTAGroup
              ctaGroupButtons={{
                ctaGroup,
                number: orderDetailItems?.orderNumber,
                resendOrder: {
                  number: ctaGroup[0]?.value,
                  buttonText: ctaGroup[0]?.label,
                  processing: processingText,
                  error: pleaseTryAgain,
                  success: successText,
                },
              }}
            />
          </div>
        </Column>
        )}
      </Row>
      <hr />
      <OrderItemsContainer
        orderProducts={products}
        packages={packages}
        text={queryData?.textFor}
      />
      <OrderSummary
        shippingDetails={shippingDetails}
        billingInfo={billingInfo}
        vatDutyDetails={vatDutyDetails}
      />
    </div>
  );
}

OrderDetailsContent.propTypes = orderDetailsDataProps;
OrderDetailsContent.defaultProps = orderDetailsDataDefaultProps;
